export interface SkillDefinition {
  id: string;
  name_he: string;
  name_en: string;
  description_he: string;
  description_en: string;
  category: SkillCategory;
  icon: string;
  color: SkillColor;
  estimated_minutes_saved: number;
  input_schema: InputField[];
  estimated_cost_saved: number;
  is_published: boolean;
  sort_order: number;
  custom_prompt: string | null;
  created_at: string;
}

export interface InputField {
  key: string;
  label_he: string;
  type: 'text' | 'number' | 'boolean' | 'select';
  required: boolean;
  default?: unknown;
  options?: { value: string; label: string }[];
}

export interface CompanySkill {
  id: string;
  company_id: string;
  skill_id: string;
  user_id: string;
  name_override: string | null;
  config: Record<string, unknown>;
  schedule_type: ScheduleType;
  schedule_day: number | null;
  schedule_hour: number;
  notify_on_complete: boolean;
  notify_on_error: boolean;
  is_active: boolean;
  last_run_at: string | null;
  next_run_at: string | null;
  created_at: string;
  skill_definitions?: SkillDefinition;
}

export interface WorkflowDefinition {
  id: string;
  company_id: string;
  user_id: string;
  name: string;
  description: string | null;
  schedule_type: ScheduleType;
  schedule_day: number | null;
  schedule_hour: number;
  notify_on_complete: boolean;
  notify_on_error: boolean;
  is_active: boolean;
  last_run_at: string | null;
  next_run_at: string | null;
  created_at: string;
  workflow_steps?: WorkflowStep[];
}

export interface WorkflowStep {
  id: string;
  workflow_id: string;
  company_skill_id: string;
  step_order: number;
  company_skills?: CompanySkill;
}

export interface SkillExecution {
  id: string;
  company_id: string;
  user_id: string | null;
  company_skill_id: string | null;
  workflow_id: string | null;
  trigger_type: 'manual' | 'scheduled';
  status: 'pending' | 'running' | 'success' | 'error';
  steps_log: StepLog[];
  output_summary: string | null;
  error_message: string | null;
  started_at: string;
  finished_at: string | null;
  duration_ms: number | null;
  company_skills?: CompanySkill;
  workflow_definitions?: WorkflowDefinition;
}

export interface StepLog {
  step_name: string;
  status: 'success' | 'error';
  output: { sql?: string; rows?: Record<string, unknown>[]; row_count?: number; type?: string; analysis?: string; filename?: string } | null;
  error?: string;
  duration_ms: number;
}

export type SkillCategory = 'hr' | 'accounting' | 'inventory' | 'sales' | 'integrations' | 'custom';
export type ScheduleType = 'manual' | 'daily' | 'weekly' | 'monthly';
export type SkillColor = 'blue' | 'emerald' | 'amber' | 'rose' | 'slate' | 'violet';

export const CATEGORY_LABELS: Record<SkillCategory, string> = {
  hr: 'עובדים ושכר',
  accounting: 'הנהלת חשבונות',
  inventory: 'ניהול מלאי',
  sales: 'מכירות ולקוחות',
  integrations: 'אינטגרציות',
  custom: 'מותאם אישית',
};

export const CATEGORY_COLORS: Record<SkillCategory, string> = {
  hr: 'emerald',
  accounting: 'blue',
  inventory: 'amber',
  sales: 'rose',
  integrations: 'violet',
  custom: 'slate',
};

export const SCHEDULE_LABELS: Record<ScheduleType, string> = {
  manual: 'הרצה ידנית',
  daily: 'כל יום',
  weekly: 'כל שבוע',
  monthly: 'כל חודש',
};
